import { t } from '../i18n/nl.js';

export default function ConfirmModal({ title, body, onConfirm, onClose, confirmLabel, danger = false }) {
  return (
    <div className="modal-overlay">
      <div className="modal" style={{ maxWidth: 480 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <p style={{ marginBottom: 24, color: 'var(--color-text-muted)', lineHeight: 1.6 }}>{body}</p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
          <button className="btn btn-ghost" onClick={onClose}>{t('facturen.annuleren')}</button>
          <button
            className="btn btn-primary"
            style={danger ? { background: '#dc2626', borderColor: '#dc2626', color: '#fff' } : {}}
            onClick={onConfirm}
          >
            {confirmLabel || t('facturen.bevestigen')}
          </button>
        </div>
      </div>
    </div>
  );
}
